import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { FormGroup } from '@/components/Form'
import { MultiStringSelect } from '@/features/iam/providers/components/StringSelect'
import { SOFTWARE_VALUES } from '@/features/iam/providers/well-known-provider-values'
import { byDesign } from '@/infra/design'
import imgConfirmationUrl from '@/assets/misc/img_confirmation.svg'
import TeamRolesIllustration from '@/components/SpotIllustration/TeamRolesIllustration'

export interface ProSoftwareReviewModalProps {
  showing: boolean
  hasDetails: boolean
  softwareOwned: string[]
  onSoftwareOwnedChange: (value: string[]) => void
  onConfirm: () => unknown
  isConfirmPending: boolean
}

export function ProSoftwareReviewModal({
  showing,
  hasDetails,
  softwareOwned,
  onSoftwareOwnedChange,
  onConfirm,
  isConfirmPending,
}: ProSoftwareReviewModalProps) {
  const testId = 'pro-software-review'
  return (
    <ModalSheet showing={showing} disableCloseOnOutsideClick disableCloseOnEsc>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgConfirmationUrl}
            illustration={byDesign(undefined, TeamRolesIllustration)}
            alt="Review your software stack"
          />
          <ModalSheetContentTitle>
            Review your software stack
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Is your software the same? If it has changed, update to discover new
            business opportunities and unlock growth potential
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
        {hasDetails && (
          <ModalSheetContentBlock>
            <FormGroup label="Software Owned">
              <MultiStringSelect
                value={softwareOwned}
                options={SOFTWARE_VALUES}
                onChange={onSoftwareOwnedChange}
                placeholder="Select software"
                testId={`${testId}-software-owned`}
              />
            </FormGroup>
          </ModalSheetContentBlock>
        )}
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Confirm"
            variant="primary"
            onPress={onConfirm}
            isPending={isConfirmPending}
            testId={`${testId}-confirm`}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
